<div id="maintenance-equipments">
  <div class="container-fluid">
    <h1>EQUIPAMENTOS DE MANUTENÇÃO</h1>

    <div class="row" *ngFor="let relationship of relationships; let i = index">
      <div class="col">
        <label>
          <span>ÁREA RESPONSÁVEL</span>

          <select
            [(ngModel)]="relationship.cdArea"
            (ngModelChange)="dsArea(i, $event); outputRelationships()"
          >
            <option value="">Selecione uma área</option>
            <option *ngFor="let area of areas" [value]="area.cdArea">{{
              area.dsArea
            }}</option>
          </select>
        </label>

        <button class="remove" *ngIf="i > 0" (click)="removeRelationship(i)">
          REMOVER RELACIONAMENTO
        </button>
      </div>

      <div class="col">
        <div class="title">EQUIPAMENTOS</div>

        <fieldset class="icn-search">
          <app-autocomplete
            [placeHolder]="placeHolder"
            [notFoundText]="notFoundText"
            [searchKeyword]="searchKeywordEquipments"
            [data]="autocompleteDataEquipments"
            (selected)="onSelectEquipments(i, $event); outputRelationships()"
            [itemTemplate]="templateEquipments"
            [notFoundTemplate]="notFoundEquipments"
            #autocompleteEquipments
          >
          </app-autocomplete>

          <ng-template #templateEquipments let-item>
            <a [innerHTML]="item.dsProduto"></a>
          </ng-template>

          <ng-template #notFoundEquipments let-notFound>
            <div [innerHTML]="notFound"></div>
          </ng-template>
        </fieldset>

        <div class="tag" *ngFor="let equipment of relationship.equipamentos">
          {{ equipment.dsProduto }} ({{ equipment.vlProduto | currencyFormat }})
          <button
            class="icn-close"
            (click)="removeEquipments(i, equipment)"
          ></button>
        </div>

        <div class="no-selected" *ngIf="relationship.equipamentos.length == 0">
          NENHUM EQUIPAMENTO SELECIONADO
        </div>
      </div>
    </div>

    <button class="add" (click)="addRelationship()">
      ADICIONAR OUTRO RELACIONAMENTO
    </button>
  </div>
</div>
